import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const RequireAuth = ({ children }) => {
  const auth = useAuth();
  const location = useLocation();

  // Handle case where auth context is null
  if (!auth) {
    return null;
  }

  const { user, loading } = auth;

  // Show loading state if authentication is in progress
  if (loading) {
    return <div>Loading...</div>;
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
};

export default RequireAuth; 